import { style } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { IonRouterOutlet, ModalController, NavController, Platform } from '@ionic/angular';

import { ImageViewerComponent } from '../component/image-viewer/image-viewer/image-viewer.component';
import { IdPage } from '../id/id.page';
import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';
import { DataService } from '../services/data.service';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit {
  ads;
  categories;
  user;
  campus: number;
  hasUnreadNotifications: boolean;
  @ViewChild(IonRouterOutlet) routerOutlet: IonRouterOutlet;

  constructor(
    private apiService: ApiService,
    private auth: AuthService,
    private router: Router,
    private modalCtrl: ModalController,
    private dataService: DataService,
    private platform: Platform,
    private navCtrl: NavController,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {}

  ionViewWillEnter() {
    // Get the auth user and check if has switch campus since the last time the home page was loaded
    // if so, retrieve categories and carousel for the selected campus.
    this.auth.getUser().then((user) => {
      this.user = user;
      if (this.user.campus_current !== this.campus) {
        this.campus = this.user.campus_current;
        this.getCarousel();
        this.getCategories();
      }
      this.notificationService.handlerNotifications();
    });
  }

  getCarousel() {
    this.apiService.getData('carousels').then(
      (res) => {
        if (!res || typeof res !== 'object' || !res.data) {
          this.ads = null;
        } else if (JSON.stringify(res.data) !== JSON.stringify(this.ads)) {
          this.ads = res.data;
        }
      },
      (err) => {
        // this.presentToast('Error de conexión con el servidor. Intente nuevamente más tarde.');
        console.log(JSON.stringify(err));
      }
    );
  }

  async getCategories() {
    const aux = (await this.apiService.getData('categories?category_id=null')).data || null;
    if (aux && JSON.stringify(aux) !== JSON.stringify(this.categories)) {
      this.categories = aux;
    }
  }

  goCategory(category) {
    console.log('goCategory: ', category.id);
    this.dataService.setData(category.id, category);
    this.navCtrl.navigateForward('/tecservice/home/category/' + category.id);
  }

  goBusinesses(category) {
    console.log('goBusinesses: ', category.id);
    this.dataService.setData(category.id, category);
    this.navCtrl.navigateForward('/tecservice/home/businesses/' + category.id);
  }

  async viewImage(src: any, title: string = '', description: string = '') {
    if (this.platform.is('ios')) {
      Haptics.impact({ style: ImpactStyle.Medium });
    }
    const modal = await this.modalCtrl.create({
      component: ImageViewerComponent,
      componentProps: {
        imgSource: src,
        imgTitle: title,
        imgDescription: description,
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    return await modal.present();
  }

  async goId() {
    const modal = await this.modalCtrl.create({
      component: IdPage,
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    return await modal.present();
  }

  goNotifications() {
    this.router.navigate(['/tecservice/home/notifications']);
  }

  navigateToProfile() {
    // this.events.publish("back:enable");
    // this.router.navigate(['/tecservice/home/businesses']);
    // this.navCtrl.navigateRoot(`/tecservice/profile/points-history`);
  }

  goLocatec() {
    this.router.navigate(['/tecservice/locatec/welcome']);
  }
}
